/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";

import VisibilityIcon from '@mui/icons-material/Visibility';
import DeleteIcon from '@mui/icons-material/Delete';

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

function Author({ image, name, email }) {
 
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="full"/>
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

function StudentData({student,client}){
    return(
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="caption" color="text" fontWeight="medium">{student}</ArgonTypography>
        <ArgonTypography variant="caption" color="text" fontWeight="medium">Client-{client}</ArgonTypography>
      </ArgonBox>
    )
}

// Attendance component
function AttendanceProgress({ percentage, label = "Attendance" }) {
  return (
    <ArgonBox>
      {/* Label */}
      <ArgonBox display="flex" justifyContent="space-between" mb={1}>
        <ArgonTypography variant="caption" fontWeight="medium" color="text">
          {"12 July 2024"}
        </ArgonTypography>
        
      </ArgonBox>
      
      {/* Progress Bar Container */}
      <ArgonBox
        width="180%"
        height="10px"
        bgColor="grey-200"
        borderRadius="lg"
        position="relative"
        overflow="hidden"
      >
        {/* Progress Fill */}
        <ArgonBox
          width={`${percentage}%`}
          height="100%"
          // bgColor={percentage >= 80 ? "success" : percentage >= 60 ? "warning" : "error"}
          bgColor="primary"
          borderRadius="lg"
          position="absolute"
          top={0}
          left={0}
        />
      </ArgonBox>
    </ArgonBox>
  );
}






const authorsTableData = {
  columns: [

    // { name: "author", align: "left" },
    // { name: "function", align: "left" },
    // { name: "status", align: "center" },
    // { name: "employed", align: "center" },
    // { name: "action", align: "center" },

    {name:"sno",align:"center"},
    {name:"Name(Mobile)",align:"left"},
    {name:"Refferal wallet", align:"left"},
    {name:"Refferel income",align:"center"},
    {name:"Invited referral",align:"center"},
    {name:"Request date",align:"center"},
    {name:"Request amount",align:"center"},
    {name:"Pay Amount",align:"center"},
    {name:"Pay date",align:"center"},
    {name:"Status",align:"center"},
    {name:"Screen Shot",align:"center"},
    {name:"Transaction id",align:"center"},
    {name:"Upi Id",align:"center"},
    {name:"Action",align:"center"},
  ],



  rows: [
  {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
    "Name(Mobile)": <Author image={team2} name="Rajesh Sharma" email="9876543210" />,
    "Refferal wallet": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,500</ArgonTypography>,
    "Refferel income": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹500</ArgonTypography>,
    "Invited referral": <ArgonTypography variant="caption" color="text" fontWeight="medium">5</ArgonTypography>,
    "Request date": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
    "Request amount": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay Amount": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay date": <ArgonTypography variant="caption" color="text" fontWeight="medium">16 Dec 2024</ArgonTypography>,
    "Status": <ArgonBadge variant="gradient" badgeContent="Paid" color="success" size="xs" container />,
    "Screen Shot": <ArgonTypography variant="caption" color="primary" fontWeight="medium">View</ArgonTypography>,
    "Transaction id": <ArgonTypography variant="caption" color="text" fontWeight="medium">TXN123456789</ArgonTypography>,
    "Upi Id": <ArgonTypography variant="caption" color="text" fontWeight="medium">rajesh@paytm</ArgonTypography>,
    "Action": (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
   {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
    "Name(Mobile)": <Author image={team2} name="Rajesh Sharma" email="9876543210" />,
    "Refferal wallet": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,500</ArgonTypography>,
    "Refferel income": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹500</ArgonTypography>,
    "Invited referral": <ArgonTypography variant="caption" color="text" fontWeight="medium">5</ArgonTypography>,
    "Request date": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
    "Request amount": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay Amount": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay date": <ArgonTypography variant="caption" color="text" fontWeight="medium">16 Dec 2024</ArgonTypography>,
    "Status": <ArgonBadge variant="gradient" badgeContent="Paid" color="success" size="xs" container />,
    "Screen Shot": <ArgonTypography variant="caption" color="primary" fontWeight="medium">View</ArgonTypography>,
    "Transaction id": <ArgonTypography variant="caption" color="text" fontWeight="medium">TXN123456789</ArgonTypography>,
    "Upi Id": <ArgonTypography variant="caption" color="text" fontWeight="medium">rajesh@paytm</ArgonTypography>,
    "Action": (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
   {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
    "Name(Mobile)": <Author image={team2} name="Rajesh Sharma" email="9876543210" />,
    "Refferal wallet": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,500</ArgonTypography>,
    "Refferel income": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹500</ArgonTypography>,
    "Invited referral": <ArgonTypography variant="caption" color="text" fontWeight="medium">5</ArgonTypography>,
    "Request date": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
    "Request amount": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay Amount": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay date": <ArgonTypography variant="caption" color="text" fontWeight="medium">16 Dec 2024</ArgonTypography>,
    "Status": <ArgonBadge variant="gradient" badgeContent="Paid" color="success" size="xs" container />,
    "Screen Shot": <ArgonTypography variant="caption" color="primary" fontWeight="medium">View</ArgonTypography>,
    "Transaction id": <ArgonTypography variant="caption" color="text" fontWeight="medium">TXN123456789</ArgonTypography>,
    "Upi Id": <ArgonTypography variant="caption" color="text" fontWeight="medium">rajesh@paytm</ArgonTypography>,
    "Action": (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
   {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
    "Name(Mobile)": <Author image={team2} name="Rajesh Sharma" email="9876543210" />,
    "Refferal wallet": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,500</ArgonTypography>,
    "Refferel income": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹500</ArgonTypography>,
    "Invited referral": <ArgonTypography variant="caption" color="text" fontWeight="medium">5</ArgonTypography>,
    "Request date": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
    "Request amount": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay Amount": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay date": <ArgonTypography variant="caption" color="text" fontWeight="medium">16 Dec 2024</ArgonTypography>,
    "Status": <ArgonBadge variant="gradient" badgeContent="Paid" color="success" size="xs" container />,
    "Screen Shot": <ArgonTypography variant="caption" color="primary" fontWeight="medium">View</ArgonTypography>,
    "Transaction id": <ArgonTypography variant="caption" color="text" fontWeight="medium">TXN123456789</ArgonTypography>,
    "Upi Id": <ArgonTypography variant="caption" color="text" fontWeight="medium">rajesh@paytm</ArgonTypography>,
    "Action": (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
   {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
    "Name(Mobile)": <Author image={team2} name="Rajesh Sharma" email="9876543210" />,
    "Refferal wallet": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,500</ArgonTypography>,
    "Refferel income": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹500</ArgonTypography>,
    "Invited referral": <ArgonTypography variant="caption" color="text" fontWeight="medium">5</ArgonTypography>,
    "Request date": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
    "Request amount": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay Amount": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay date": <ArgonTypography variant="caption" color="text" fontWeight="medium">16 Dec 2024</ArgonTypography>,
    "Status": <ArgonBadge variant="gradient" badgeContent="Paid" color="success" size="xs" container />,
    "Screen Shot": <ArgonTypography variant="caption" color="primary" fontWeight="medium">View</ArgonTypography>,
    "Transaction id": <ArgonTypography variant="caption" color="text" fontWeight="medium">TXN123456789</ArgonTypography>,
    "Upi Id": <ArgonTypography variant="caption" color="text" fontWeight="medium">rajesh@paytm</ArgonTypography>,
    "Action": (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },
   {
    sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
    "Name(Mobile)": <Author image={team2} name="Rajesh Sharma" email="9876543210" />,
    "Refferal wallet": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹2,500</ArgonTypography>,
    "Refferel income": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹500</ArgonTypography>,
    "Invited referral": <ArgonTypography variant="caption" color="text" fontWeight="medium">5</ArgonTypography>,
    "Request date": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
    "Request amount": <ArgonTypography variant="caption" color="text" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay Amount": <ArgonTypography variant="caption" color="success" fontWeight="medium">₹1,000</ArgonTypography>,
    "Pay date": <ArgonTypography variant="caption" color="text" fontWeight="medium">16 Dec 2024</ArgonTypography>,
    "Status": <ArgonBadge variant="gradient" badgeContent="Paid" color="success" size="xs" container />,
    "Screen Shot": <ArgonTypography variant="caption" color="primary" fontWeight="medium">View</ArgonTypography>,
    "Transaction id": <ArgonTypography variant="caption" color="text" fontWeight="medium">TXN123456789</ArgonTypography>,
    "Upi Id": <ArgonTypography variant="caption" color="text" fontWeight="medium">rajesh@paytm</ArgonTypography>,
    "Action": (
      <ArgonBox display="flex" alignItems="center" gap={1}>
        <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
          <VisibilityIcon/>
        </ArgonTypography>
        <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
          <DeleteIcon/>
        </ArgonTypography>
      </ArgonBox>
    ),
  },

]


//  rows: [
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
//     "Question": <ArgonTypography variant="caption" color="text" fontWeight="medium">How do I reset my password?</ArgonTypography>,
//     "Answer": <ArgonTypography variant="caption" color="text" fontWeight="medium">Click on 'Forgot Password' link on login page and follow the instructions.</ArgonTypography>,
//     "Priority": <ArgonBadge variant="gradient" badgeContent="High" color="error" size="xs" container />,
//     "Added ON": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
//     "Type": <ArgonTypography variant="caption" color="text" fontWeight="medium">General</ArgonTypography>,
//     "Action": (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">2</ArgonTypography>,
//     "Question": <ArgonTypography variant="caption" color="text" fontWeight="medium">How to schedule a class?</ArgonTypography>,
//     "Answer": <ArgonTypography variant="caption" color="text" fontWeight="medium">Go to Classes section and click on 'Schedule New Class' button.</ArgonTypography>,
//     "Priority": <ArgonBadge variant="gradient" badgeContent="Medium" color="warning" size="xs" container />,
//     "Added ON": <ArgonTypography variant="caption" color="text" fontWeight="medium">12 Dec 2024</ArgonTypography>,
//     "Type": <ArgonTypography variant="caption" color="text" fontWeight="medium">Classes</ArgonTypography>,
//     "Action": (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Question": <ArgonTypography variant="caption" color="text" fontWeight="medium">How to make payment?</ArgonTypography>,
//     "Answer": <ArgonTypography variant="caption" color="text" fontWeight="medium">You can make payment through UPI, Credit Card, or Bank Transfer from Payment section.</ArgonTypography>,
//     "Priority": <ArgonBadge variant="gradient" badgeContent="Low" color="success" size="xs" container />,
//     "Added ON": <ArgonTypography variant="caption" color="text" fontWeight="medium">10 Dec 2024</ArgonTypography>,
//     "Type": <ArgonTypography variant="caption" color="text" fontWeight="medium">Payment</ArgonTypography>,
//     "Action": (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Question": <ArgonTypography variant="caption" color="text" fontWeight="medium">How to make payment?</ArgonTypography>,
//     "Answer": <ArgonTypography variant="caption" color="text" fontWeight="medium">You can make payment through UPI, Credit Card, or Bank Transfer from Payment section.</ArgonTypography>,
//     "Priority": <ArgonBadge variant="gradient" badgeContent="Low" color="success" size="xs" container />,
//     "Added ON": <ArgonTypography variant="caption" color="text" fontWeight="medium">10 Dec 2024</ArgonTypography>,
//     "Type": <ArgonTypography variant="caption" color="text" fontWeight="medium">Payment</ArgonTypography>,
//     "Action": (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Question": <ArgonTypography variant="caption" color="text" fontWeight="medium">How to make payment?</ArgonTypography>,
//     "Answer": <ArgonTypography variant="caption" color="text" fontWeight="medium">You can make payment through UPI, Credit Card, or Bank Transfer from Payment section.</ArgonTypography>,
//     "Priority": <ArgonBadge variant="gradient" badgeContent="Low" color="success" size="xs" container />,
//     "Added ON": <ArgonTypography variant="caption" color="text" fontWeight="medium">10 Dec 2024</ArgonTypography>,
//     "Type": <ArgonTypography variant="caption" color="text" fontWeight="medium">Payment</ArgonTypography>,
//     "Action": (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Question": <ArgonTypography variant="caption" color="text" fontWeight="medium">How to make payment?</ArgonTypography>,
//     "Answer": <ArgonTypography variant="caption" color="text" fontWeight="medium">You can make payment through UPI, Credit Card, or Bank Transfer from Payment section.</ArgonTypography>,
//     "Priority": <ArgonBadge variant="gradient" badgeContent="Low" color="success" size="xs" container />,
//     "Added ON": <ArgonTypography variant="caption" color="text" fontWeight="medium">10 Dec 2024</ArgonTypography>,
//     "Type": <ArgonTypography variant="caption" color="text" fontWeight="medium">Payment</ArgonTypography>,
//     "Action": (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
// ]



// rows: [
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
//     "Name/Mobile_no": <Author image={team2} name="Rajesh Sharma" email="9876543210" />,
//     status: <ArgonBadge variant="gradient" badgeContent="Pending" color="warning" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">2</ArgonTypography>,
//     "Name/Mobile_no": <Author image={team3} name="Priya Patel" email="9123456789" />,
//     status: <ArgonBadge variant="gradient" badgeContent="Completed" color="success" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Name/Mobile_no": <Author image={team4} name="Amit Kumar" email="9988776655" />,
//     status: <ArgonBadge variant="gradient" badgeContent="In Progress" color="info" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//     {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Name/Mobile_no": <Author image={team4} name="Amit Kumar" email="9988776655" />,
//     status: <ArgonBadge variant="gradient" badgeContent="In Progress" color="info" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//     {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Name/Mobile_no": <Author image={team4} name="Amit Kumar" email="9988776655" />,
//     status: <ArgonBadge variant="gradient" badgeContent="In Progress" color="info" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//     {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     "Name/Mobile_no": <Author image={team4} name="Amit Kumar" email="9988776655" />,
//     status: <ArgonBadge variant="gradient" badgeContent="In Progress" color="info" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
// ]


//   rows: [
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">1</ArgonTypography>,
//     tutors: <Author image={team2} name="Dr. Priya Patel" email="priya@gmail.com" />,
//     "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Processed" color="success" size="xs" container />,
//     "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Mathematics Grade 10</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
//     mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Bank Transfer</ArgonTypography>,
//     "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">15 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">2</ArgonTypography>,
//     tutors: <Author image={team3} name="Prof. Vikash Singh" email="vikash@gmail.com" />,
//     "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Pending" color="warning" size="xs" container />,
//     "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Physics Grade 12</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="Active" color="success" size="xs" container />,
//     mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">UPI</ArgonTypography>,
//     "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">10 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     tutors: <Author image={team4} name="Dr. Sneha Gupta" email="sneha@gmail.com" />,
//     "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Failed" color="error" size="xs" container />,
//     "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Chemistry Grade 11</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="Inactive" color="secondary" size="xs" container />,
//     mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Cheque</ArgonTypography>,
//     "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">05 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//    {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     tutors: <Author image={team4} name="Dr. Sneha Gupta" email="sneha@gmail.com" />,
//     "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Failed" color="error" size="xs" container />,
//     "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Chemistry Grade 11</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="Inactive" color="secondary" size="xs" container />,
//     mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Cheque</ArgonTypography>,
//     "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">05 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//    {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     tutors: <Author image={team4} name="Dr. Sneha Gupta" email="sneha@gmail.com" />,
//     "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Failed" color="error" size="xs" container />,
//     "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Chemistry Grade 11</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="Inactive" color="secondary" size="xs" container />,
//     mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Cheque</ArgonTypography>,
//     "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">05 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//    {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     tutors: <Author image={team4} name="Dr. Sneha Gupta" email="sneha@gmail.com" />,
//     "Payroll Status": <ArgonBadge variant="gradient" badgeContent="Failed" color="error" size="xs" container />,
//     "class name": <ArgonTypography variant="caption" color="text" fontWeight="medium">Chemistry Grade 11</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="Inactive" color="secondary" size="xs" container />,
//     mode: <ArgonTypography variant="caption" color="text" fontWeight="medium">Cheque</ArgonTypography>,
//     "last payment": <ArgonTypography variant="caption" color="text" fontWeight="medium">05 Dec 2024</ArgonTypography>,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
// ]


//   rows: [
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Arvind Bhaiya"}</ArgonTypography>,
//     Raised_By: <Author image={team2} name="Rahul Sharma" email="rahul@gmail.com" />,
//     subject: <ArgonTypography variant="caption" color="text" fontWeight="medium">Login Issue</ArgonTypography>,
//     priority: <ArgonTypography variant="caption" color="text" fontWeight="medium">High</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="open" color="warning" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">2</ArgonTypography>,
//     Raised_By: <Author image={team3} name="Priya Patel" email="priya@gmail.com" />,
//     subject: <ArgonTypography variant="caption" color="text" fontWeight="medium">Payment Error</ArgonTypography>,
//     priority: <ArgonTypography variant="caption" color="text" fontWeight="medium">Medium</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="closed" color="success" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     Raised_By: <Author image={team4} name="Amit Kumar" email="amit@gmail.com" />,
//     subject: <ArgonTypography variant="caption" color="text" fontWeight="medium">Profile Update Issue</ArgonTypography>,
//     priority: <ArgonTypography variant="caption" color="text" fontWeight="medium">Low</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="pending" color="info" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     Raised_By: <Author image={team4} name="Amit Kumar" email="amit@gmail.com" />,
//     subject: <ArgonTypography variant="caption" color="text" fontWeight="medium">Profile Update Issue</ArgonTypography>,
//     priority: <ArgonTypography variant="caption" color="text" fontWeight="medium">Low</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="pending" color="info" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     Raised_By: <Author image={team4} name="Amit Kumar" email="amit@gmail.com" />,
//     subject: <ArgonTypography variant="caption" color="text" fontWeight="medium">Profile Update Issue</ArgonTypography>,
//     priority: <ArgonTypography variant="caption" color="text" fontWeight="medium">Low</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="pending" color="info" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
//   {
//     sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">3</ArgonTypography>,
//     Raised_By: <Author image={team4} name="Amit Kumar" email="amit@gmail.com" />,
//     subject: <ArgonTypography variant="caption" color="text" fontWeight="medium">Profile Update Issue</ArgonTypography>,
//     priority: <ArgonTypography variant="caption" color="text" fontWeight="medium">Low</ArgonTypography>,
//     status: <ArgonBadge variant="gradient" badgeContent="pending" color="info" size="xs" container />,
//     action: (
//       <ArgonBox display="flex" alignItems="center" gap={1}>
//         <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//           <VisibilityIcon/>
//         </ArgonTypography>
//         <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//           <DeleteIcon/>
//         </ArgonTypography>
//       </ArgonBox>
//     ),
//   },
// ]

//   rows: [
//     {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"199"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },
//    {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
//       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
//       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
//       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
//       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
//       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
//       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
//          action: (
//   <ArgonBox display="flex" alignItems="center" gap={1}>
//     {/* View Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//       <VisibilityIcon/>
//     </ArgonTypography>

//     {/* Delete Icon */}
//     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
//     <DeleteIcon/>
//     </ArgonTypography>
//   </ArgonBox>
// ),
// },

 
   
    
   
    


//     // {
//     //   author: <Author image={team2} name="John Michael" email="john@creative-tim.com" />,
//     //   function: <Function job="Manager" org="Organization" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       23/04/18
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },


//     // {
//     //   author: <Author image={team3} name="Alexa Liras" email="alexa@creative-tim.com" />,
//     //   function: <Function job="Programator" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       11/01/19
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team4} name="Laurent Perrier" email="laurent@creative-tim.com" />,
//     //   function: <Function job="Executive" org="Projects" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       19/09/17
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team3} name="Michael Levi" email="michael@creative-tim.com" />,
//     //   function: <Function job="Programator" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       24/12/08
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team2} name="Richard Gran" email="richard@creative-tim.com" />,
//     //   function: <Function job="Manager" org="Executive" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       04/10/21
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//     // {
//     //   author: <Author image={team4} name="Miriam Eric" email="miriam@creative-tim.com" />,
//     //   function: <Function job="Programtor" org="Developer" />,
//     //   status: (
//     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
//     //   ),
//     //   employed: (
//     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
//     //       14/09/20
//     //     </ArgonTypography>
//     //   ),
//     //   action: (
//     //     <ArgonTypography
//     //       component="a"
//     //       href="#"
//     //       variant="caption"
//     //       color="secondary"
//     //       fontWeight="medium"
//     //     >
//     //       Edit
//     //     </ArgonTypography>
//     //   ),
//     // },
//   ],
};

export default authorsTableData;
